import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AuthenticationWeatherApiTokenStore } from '@navfleet/client/authentication/domain/data-access';
import { environment } from '@navfleet/shared/core/environment';
import { EMPTY, Observable } from 'rxjs';

@Injectable()
export class MapWeatherTokenApiInterceptor implements HttpInterceptor {
    private readonly weatherApiTokenStore = inject(AuthenticationWeatherApiTokenStore);

    /**
     * Intercepts HttpRequests to the Navtor Weather Api and adds a token
     * to the requests header.
     * @param request The HttpRequest to intercept
     * @param next The HttpHandler to handle the request
     */
    public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const paths = ['weather/global-storms', 'weather/grid-tiles', 'weather/fronts', 'weather/contours'];

        if (
            (request.url.includes(environment.NAVTOR_API) && paths.find((p) => request.url.includes(p))) ||
            request.url.includes(environment.NOAA_TSUNAMI_API)
        ) {
            const token = this.weatherApiTokenStore.token();

            // Don't call the api if there's no token
            if (!token) {
                return EMPTY;
            }

            return next.handle(this.addTokenToRequestHeader(request, token));
        }

        return next.handle(request);
    }

    /**
     * Adds the token to the requests header
     * @param request The HttpRequest that the token should be added to
     * @param token The token that should be added to the HttpRequest
     */
    private addTokenToRequestHeader(request: HttpRequest<unknown>, token: string): HttpRequest<unknown> {
        return request.clone({
            setHeaders: {
                Authorization: `bearer ${token}`,
            },
        });
    }
}
